import { HttpClient } from '../../protocols/http/httpClient'
import { IRemoveUserFromCompany } from '../../../domain/usecases/UserRoles'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteRemoveUserFromCompany implements IRemoveUserFromCompany {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async remove(userId: string, companyId: string): Promise<void> {
    const httpResponse = await this.httpClient.delete?.({
      url: `${this.url}/user-roles/${userId}?companyId=${companyId}`
    })
    throwIfHttpError(httpResponse, 'Erro ao remover usuário')
  }
}
